<obg-m-dialog-layout
	#dialog
	[hideClose]="hideClose"
	[hideFooter]="hideFooter"
	[ngClass]="{'obg-login-flow-deposit': activeStep?.name === 'deposit'}"
>
	<obg-sequential-flow-stepper
		[showPlaceholderStep]="true"
		[stepperContainer]="dialogLayout?.nativeElement"
		[flowStartIndex]="flowStartIndex"
		[extraHeightForResizeAnimation]="40"
		[linear]="false"
		[flowSteps]="newLoginFlowSteps"
		[loading]="loading$ | async"
		[hideStepperHeader]="true"
		[stepsComponentConfiguration]="flowComponentsMap"
		(viewInitDone)="loginFlowLoaderService.toggleLoading(false)"
		(activeStepChange)="setActiveStep($event)"
		(heightChangeAnimationStart)="onHeightChangeAnimationStart()"
		(heightChangeAnimationDone)="onHeightChangeAnimationDone()"
	></obg-sequential-flow-stepper>
</obg-m-dialog-layout>
